<template>
  <component :is="name"></component>
</template>

<script>
export default {
  name: 'signTemplate',
  data() {
    return {
      name: 'bbb'
    }
  }
}
</script>

<style scoped></style>
